import './LoginFormHeader.scss';

interface IProps {
  formName?: string;
}

const FormHeader = ({ formName }: IProps) => (
  <div className="LoginFormHeader">
    <h1 className="LoginFormHeader-name font-weight-bold text-left mb-4">{formName}</h1>
  </div>
);

export default FormHeader;
